import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { X } from 'lucide-react';



type CustomEdgeProps = {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  onDeleteEdge?: (id: string) => void;
};


export function CustomEdge({ id, sourceX, sourceY, targetX, targetY, onDeleteEdge }: CustomEdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        <button
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            pointerEvents: 'all',
          }}
          className="nodrag nopan border opacity-0 hover:opacity-100 bg-gray-200 rounded hover:bg-gray-100 hover:text-red-500 transition-colors"
          onClick={() => onDeleteEdge?.(id)}
        >
          <X />
        </button>
      </EdgeLabelRenderer>
    </>
  );
}